export const contractTypes = [
  { label: "Empleado", value: "EMPLOYEE" },
  { label: "Honorarios", value: "HONORARIES" },
  { label: "Asimilados a salarios", value: "SALARY_ASSIMILATION" },
  { label: "Consultor externo", value: "EXTERNAL_CONSULTANT" }
]
